import { createContext, useContext, type ReactNode } from 'react';
import type { ChartSeries, PanelId, SeriesMoves } from './seriesTypes';

export interface ChartViewport {
    domain: [Date, Date];
    bounds: [Date, Date];
    cursor: number | null;
    cursorPanel: PanelId | null;
    setCursor: (t: number | null, panel?: PanelId) => void;
    zoomAt: (t: number, factor: number) => void;
    panBy: (deltaMs: number) => void;
    reset: () => void;
    allSeries: readonly ChartSeries[];
    moves: SeriesMoves;
    moveSeries: ((seriesId: string, target: PanelId) => void) | null;
    hidePanel: ((panel: PanelId) => void) | null;
    panelExtras: Readonly<Record<string, ReactNode>>;
    panelOverlays: Readonly<Record<string, ReactNode>>;
    panelTitles: Readonly<Record<string, string>>;
}

export const ViewportContext = createContext<ChartViewport | null>(null);

export function useViewport(): ChartViewport {
    const viewport = useContext(ViewportContext);
    if (!viewport) {
        throw new Error('useViewport must be used inside a ChartStack');
    }
    return viewport;
}
